var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { slotName } from './slotUtils';
import Tappable from 'react-tappable';
var SlotTitle = function (props) {
    var slot = props.slot, outcome = props.outcome, gridLocalization = props.gridLocalization, match = props.match, click = props.click, longTouch = props.longTouch;
    return (_jsx(Tappable, __assign({ className: 'title toggle tappable-header', onClick: click, onPress: longTouch, stopPropagation: true }, { children: _jsx("div", __assign({ className: 'name' }, { children: slotName(slot, outcome, gridLocalization, match) })) })));
};
SlotTitle.propTypes = {
    slot: PropTypes.object.isRequired,
    outcome: PropTypes.object.isRequired,
    gridLocalization: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    click: PropTypes.func.isRequired
};
export default SlotTitle;



// WEBPACK FOOTER //
// ./src/components/grid/event/slots/SlotTitle.jsx